import Vue from "vue"
import { MutationTree, ActionTree, GetterTree } from "vuex"

export const state = () => ({
  list: [] as Notification[],
  last_reads: {} as Record<number, number>,
})
export type NotificationState = ReturnType<typeof state>
import Notification from "~/types/notification"
import { RootState } from "~/store"
import Band from "~/types/band"

export const mutations: MutationTree<NotificationState> = {
  SET_LAST_READS: function (state, last_reads: Record<number, number>) {
    Vue.set(state, "last_reads", last_reads)
    if (process.client) {
      for (const id in last_reads)
        window.localStorage.setItem(
          `last_notif_seen_${id}`,
          last_reads[Number(id)].toString()
        )
    }
  },
  SET_LAST_READ: function (
    state,
    { value, id }: { value: string; id: number }
  ) {
    Vue.set(state.last_reads, id, parseInt(value))
    if (process.client)
      window.localStorage.setItem(`last_notif_seen_${id}`, value.toString())
  },
  SET: function (state, notifications: Notification[]) {
    for (let i = notifications.length - 1; i >= 0; i--)
      state.list.push(notifications[i])
  },
  PUSH: function (state, newNotification: Notification) {
    if (
      !state.list
        .map((notification) => notification.id)
        .includes(newNotification.id)
    )
      state.list.push(newNotification)
  },
  RESET: function (state) {
    state.list.splice(0, state.list.length)
  },
  UPDATE_IDS: function (state, ids: number[]) {
    state.list.forEach((notification) => {
      if (ids.includes(notification.id))
        notification.datetime_seen = new Date().getTime()
    })
  },
}

export const actions: ActionTree<NotificationState, RootState> = {
  FETCH_LAST_READS({ rootState, commit }) {
    if (process.client) {
      //@ts-ignore
      const bandSet: Band[] = rootState.user.band_set

      commit(
        "SET_LAST_READS",
        bandSet.reduce((accumulator: Record<number, number>, band: Band) => {
          const value: string | null = window.localStorage.getItem(
            `last_notif_seen_${band.id}`
          )

          if (value) accumulator[band.id] = parseInt(value)
          return accumulator
        }, {})
      )
    }
  },
  ADD({ commit, rootState }, newNotification: Notification) {
    //TODO Store - Infer band id type ?
    //@ts-ignore
    if (rootState.user.band.id === newNotification.receiver) {
      commit("PUSH", newNotification)
      return true
    }
    return false
  },
  async GET_ALL_NOTIFICATIONS({ commit, rootGetters }) {
    return new Promise((resolve) => {
      if (rootGetters["user/IS_LOGGED_IN"] as boolean) {
        this.$axios
          .$get("/notification/notification/?limit=50")
          .then(({ results }: { results: Notification[] }) => {
            commit("RESET")
            commit("SET", results || [])
            resolve(results || [])
          })
          .catch((err) => {
            //@ts-ignore
            this.$sentry.captureException(err)
            resolve([])
          })
      } else resolve([])
    })
  },
  async GET_NOTIFICATIONS_BY_BAND({ commit, rootGetters }) {
    return new Promise((resolve, reject) => {
      if (rootGetters["user/IS_LOGGED_IN"] as boolean) {
        this.$axios
          .$get("/notification/notification/")
          .then(({ results }: { results: Notification[] }) => {
            commit("RESET")
            commit("SET", results || [])
            resolve(results || [])
          })
          .catch((err) => {
            //@ts-ignore
            this.$sentry.captureException(err)
            reject(err)
          })
      } else resolve([])
    })
  },
  MARK_AS_SEEN({ commit }, ids: number[]) {
    return this.$axios
      .$post("/notification/notification/seen/", {
        ids,
      })
      .then(() => {
        commit("UPDATE_IDS", ids)
      })
      .catch((err) => {
        console.log(err)
      })
  },
  async MARK_ALL_AS_SEEN({ dispatch }) {
    const notifArr: Notification[] = await dispatch("GET_ALL_NOTIFICATIONS")
    const ids = notifArr
      .filter((notification) => {
        return !notification.sent
      })
      .map((notification) => notification.id)

    dispatch("MARK_AS_SEEN", ids)
  },
}

export const getters: GetterTree<NotificationState, RootState> = {
  SELECTED_LAST_SEEN: function (state, _getters, rootState) {
    //TODO Store - Infer band id type ?
    //@ts-ignore
    return state.last_reads[rootState.user.band.id]
  },
}
